import { setShowSelectEstimateOptionalsModal } from '../State/showSelectEstimateOptionalsModal';

export default () => async (dispatch) => {

  dispatch(setShowSelectEstimateOptionalsModal(false));
  
}